import { render, staticRenderFns } from "./MissionAndVision.vue?vue&type=template&id=1c63b3dc&scoped=true&"
import script from "./MissionAndVision.vue?vue&type=script&lang=js&"
export * from "./MissionAndVision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c63b3dc",
  null
  
)

export default component.exports